module.exports = "https://cdn.zapier.com/blog/d5243069571f03e9d29781d99557774902231274/_next/static/images/orange-cc7d7511764b8e94e76fbcd163b076ff.png";